/**
 * Helpers typés pour persister l'état d'appairage de la tablette en localStorage.
 * Le mode tablette est un kiosk dédié — le token y survit aux reboots.
 */

const KEYS = {
  token: "tablet_device_token",
  deviceId: "tablet_device_id",
  organizationId: "tablet_organization_id",
} as const

export const tabletStorage = {
  getToken(): string | null {
    return localStorage.getItem(KEYS.token)
  },

  getDeviceId(): string | null {
    return localStorage.getItem(KEYS.deviceId)
  },

  getOrganizationId(): string | null {
    return localStorage.getItem(KEYS.organizationId)
  },

  setPairing(token: string, deviceId: string, organizationId: string): void {
    localStorage.setItem(KEYS.token, token)
    localStorage.setItem(KEYS.deviceId, deviceId)
    localStorage.setItem(KEYS.organizationId, organizationId)
  },

  clear(): void {
    localStorage.removeItem(KEYS.token)
    localStorage.removeItem(KEYS.deviceId)
    localStorage.removeItem(KEYS.organizationId)
  },

  isPaired(): boolean {
    return !!localStorage.getItem(KEYS.token)
  },
} as const
